import DataObject from '../../../common/model/DataObject';

export default class ContractRange extends DataObject {
  getPropertyNames() {
    return [
      'guid',
      'startDate',
      'endDate',
      'rangeViewerRole',
      'rangeEditorRole',
      'scheduleCount'
    ];
  }
}